import styled from "styled-components";

export const ContainerStyle = styled.section`
  position: fixed;
  top: 0%;
  padding: 3rem;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  z-index: 100000;
  text-align: center;
  flex-direction: column;
  .logo {
    direction: rtl;
    display: flex;
    margin-bottom: 0.5rem;
    font-size: 3.2rem;
    h2 {
      color: #89beff;
    }
  }
  h2 {
    color: gray;
  }
`;
